import { pushEvent } from 'src/client/data-layer';

export enum FilterScope {
  CATEGORY = 'Category',
  CAMPAIGN = 'Campaign',
  SEARCH = 'Search',
  PRODUCT = 'Product',
}

export type FilterLayouts =
  | 'facet-navigation'
  | 'quick-filter'
  | 'sidebar-filters'
  | 'mobile-overlay'
  | 'product-name-search'
  | 'campaign-filter';

export type FilterTypes =
  | 'list'
  | 'list-tree'
  | 'boolean'
  | 'range'
  | 'range-groups'
  | 'product-name-search'
  | 'campaign-name-search'
  | 'popular-deals'
  | 'facet-navigation';

export const trackFilterSelectEvent = (data: {
  value: string;
  scope: FilterScope | null;
  property: string;
  layout: FilterLayouts | null;
  type: FilterTypes;
  category?: string | null | undefined;
  campaign?: string | null | undefined;
}) => {
  let eventData = data;
  if (!data.category) eventData = { ...data, category: '' };
  if (!data.campaign) eventData = { ...data, campaign: '' };
  pushEvent('filterSelect', eventData);
};
